import { memo } from 'react'

import Legal, { TEST_ID } from './Legal'

const LegalComponent = memo(Legal)

export { TEST_ID }

export default LegalComponent
